
(function () {
  "use strict";

  const GRID_SELECTOR = "ul.product-grid";
  const CARD_SELECTOR = ".card-wrapper[data-stock-available]";

  function updateProductGrid(grid) {
    if (!grid) return;

    const cards = grid.querySelectorAll(CARD_SELECTOR);

    cards.forEach(function (card) {
      const item = card.closest("li.grid__item");
      if (!item) return;

      const isSoldOut =
        card.getAttribute("data-stock-available") === "false";

      if (isSoldOut) {
        item.hidden = true;
        item.setAttribute("data-sold-out-hidden", "true");
      } else if (item.getAttribute("data-sold-out-hidden") === "true") {
        item.hidden = false;
        item.removeAttribute("data-sold-out-hidden");
      }
    });

    // Flex layout ko available cards ke according recalculate karne do.
    grid.style.flexWrap = "wrap";
    grid.style.alignItems = "stretch";
  }

  function updateAllGrids() {
    document.querySelectorAll(GRID_SELECTOR).forEach(updateProductGrid);
  }

  function init() {
    updateAllGrids();

    let scheduled = false;

    const observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(function () {
        scheduled = false;
        updateAllGrids();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-stock-available"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
